import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Grid, Menu, MenuItem, Typography } from "@mui/material";
import moment from "moment";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  getAllClinicPayment,
  getH1RecordsWithFilter,
  getRecentTransactionsPayment,
} from "../../../redux/reducers/clinicSlice";
import { deletePaymentById } from "../../../redux/reducers/paymentSlice";
import { baseURL } from "../../../util/server";
import VetAndUpcomingAppointments from "../../CommonScreens/VetAndUpcomingAppointments/VetAndUpcomingAppointments";
import Discount from "../ComingSoon/cards/Discount";
import PaymentMethod from "../ComingSoon/cards/PaymentMethod";
import Main from "./Billing/Main"; // Add this import for your App component
import Payments from "./Payment";
import PaymentDashboard from "./PaymentDashboard";
import PointOfSaleNew from "./PointOfSaleNew";
import Returns from "./Returns";

const tblHdrs = [
  "date",
  "invoiceNumber",
  "tradeName",
  "quantity",
  "batchNo",
  "expirtDate",
  // "userName",
  "customerName",
  "petName",
  "doctorName",
  "userAddress",
];

const getYearOptions = () => {
  const currentYear = moment().year();
  return Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { name: String(year), value: year };
  });
};

const getMonthOptions = (selectedYear) => {
  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;
  const maxMonth = selectedYear === currentYear ? currentMonth - 1 : 12;
  if (maxMonth < 1) return [];
  return moment
    ?.months()
    ?.slice(0, maxMonth)
    ?.map((name, index) => ({
      name,
      value: index + 1,
    }));
};

const getDefaultPeriod = () => {
  const now = moment();
  const currentYear = now.year();
  const currentMonth = now.month() + 1;
  if (currentMonth === 1) {
    return { year: currentYear - 1, month: 12 };
  }
  return { year: currentYear, month: currentMonth - 1 };
};

const DATE_RANGE_REPORT_TYPES = [
  "accounts-receivables",
  "consolidated-financial-summary",
];

const isDateRangeReport = (type) => DATE_RANGE_REPORT_TYPES.includes(type);

const getReportModalHeader = (type) => {
  switch (type) {
    case "gst":
      return "GST Report";
    case "hsn":
      return "HSN Summary";
    case "accounts-receivables":
      return "Accounts Receivables Report";
    case "consolidated-financial-summary":
      return "Consolidated Financial Summary";
    default:
      return "Report";
  }
};

const formatReportDateRange = (start, end) => {
  const date1 = moment(new Date(start));
  const date2 = moment(new Date(end));
  return {
    startDate: (date1.isBefore(date2) ? date1 : date2).format("YYYY-MM-DD"),
    endDate: (date1.isBefore(date2) ? date2 : date1).format("YYYY-MM-DD"),
  };
};

const QUARTER_RANGES = [
  { label: "Jan-Mar", startMonth: 0, endMonth: 2 },
  { label: "Apr-Jun", startMonth: 3, endMonth: 5 },
  { label: "Jul-Sept", startMonth: 6, endMonth: 8 },
  { label: "Oct-Dec", startMonth: 9, endMonth: 11 },
];

const getLastFourQuarters = () => {
  const now = moment();
  let year = now.year();
  let quarterIndex = Math.floor(now.month() / 3);
  const quarters = [];

  for (let i = 0; i < 4; i += 1) {
    const quarter = QUARTER_RANGES[quarterIndex];
    quarters.push({
      name: `${quarter.label} ${year}`,
      startDate: moment({ year, month: quarter.startMonth, day: 1 }).format(
        "YYYY-MM-DD",
      ),
      endDate: moment({ year, month: quarter.endMonth, day: 1 })
        .endOf("month")
        .format("YYYY-MM-DD"),
    });
    quarterIndex -= 1;
    if (quarterIndex < 0) {
      quarterIndex = 3;
      year -= 1;
    }
  }

  return quarters;
};

const ClinicPayments = () => {
  const dispatch = useDispatch();
  const [posPayId, setPosPayId] = useState(null);
  const [paymentTableType, setPaymentTableType] = useState(null);
  const [selectedPaymentTab, setSelectedPaymentTab] = useState("Pending");
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [selectedPayment, setSelecetdPayment] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [subTab, setSubTab] = useState(null);
  const [masterAnchorEl, setMasterAnchorEl] = useState(null);
  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  const [h1ReportModValues, setH1ReportModValues] = useState({
    visible: false,
  });
  const [reportModalValues, setReportModalValues] = useState({
    visible: false,
  });
  const [ndpsReportValues, setNdpsReportValues] = useState({
    visible: false,
    quarter: null,
  });
  const [page, setPage] = useState(1);
  const [posModVsble, setPosModVsble] = useState(false);
  const { details: clinicDetail, h1Records } = useSelector(
    (state) => state?.clinic,
  );
  const itemSize = 10;
  const defaultUrl = "?filter=all&type=resent";
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinic: clinicData, stocks } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, stocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
      };
    } catch {
      return { clinic: {}, stocks: [] };
    }
  }, [mandateDataRaw]);
  const clinicDet = clinicData?.id ? clinicData : clinicDetail;

  const onH1ApiCall = (pge = 1) => {
    setPage(pge);
    const stockIds = h1ReportModValues?.stockName?.map((li) => li?.value);
    const date1 = moment(new Date(h1ReportModValues?.startDate));
    const date2 = moment(new Date(h1ReportModValues?.endDate));
    const startDate = (date1.isBefore(date2) ? date1 : date2).format(
      "YYYY-MM-DD",
    );
    const endDate = (date1.isBefore(date2) ? date2 : date1).format(
      "YYYY-MM-DD",
    );
    const url = `?clinicId=${clinicDet?.id}&stockIds=${stockIds}&startDate=${startDate}&endDate=${endDate}&page=${pge}&itemSize=${itemSize}`;
    dispatch(getH1RecordsWithFilter(url));
  };

  const handleEdit = (dta) => {
    setActiveTab("PointOfSales");
    setSelecetdPayment(dta);
    setPaymentId(dta?.paymentId);
  };

  const handleChangeTab = (tab) => {
    setSelecetdPayment(null);
    setPaymentId(null);
    setActiveTab(tab);
    setSubTab(null);
  };

  const handleDelete = (pay) => {
    setPaymentId(pay?.paymentId);
    setDelModVsble(true);
  };

  const handleCloseDelMod = () => {
    setPaymentId(null);
    setDelModVsble(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deletePaymentById(paymentId)).then((res) => {
      if (res?.payload) {
        handleCloseDelMod();
        dispatch(getRecentTransactionsPayment(defaultUrl));
        dispatch(
          getAllClinicPayment(`?filter=all&type=all&page=1&itemSize=10`),
        );
      }
    });
  };

  const handleChangeMaster = (val) => {
    setActiveTab("Master");
    setMasterAnchorEl(null);
    setSubTab(val);
  };

  const handleChangeReport = (val) => {
    const stockIds = h1ReportModValues?.stockName?.map((li) => li?.value);
    const date1 = moment(new Date(h1ReportModValues?.startDate));
    const date2 = moment(new Date(h1ReportModValues?.endDate));
    const startDate = (date1.isBefore(date2) ? date1 : date2).format(
      "YYYY-MM-DD",
    );
    const endDate = (date1.isBefore(date2) ? date2 : date1).format(
      "YYYY-MM-DD",
    );
    const url = `${baseURL}/clinic/payment/schedule-h1/export?clinicId=${clinicDet?.id}&stockIds=${stockIds}&startDate=${startDate}&endDate=${endDate}`;
    window.open(url, "_blank");
  };

  const onOpenH1Report = () => {
    setReportAnchorEl(null);
    setH1ReportModValues({
      visible: true,
      stockName: getH1Stocks(),
      // stockName: [],
      startDate: new Date(),
      endDate: new Date(),
    });
  };

  const onOpenPeriodReport = (type) => {
    setReportAnchorEl(null);
    const { year, month } = getDefaultPeriod();
    setReportModalValues({
      visible: true,
      type,
      year,
      month,
    });
  };

  const onOpenDateRangeReport = (type) => {
    setReportAnchorEl(null);
    setReportModalValues({
      visible: true,
      type,
      startDate: new Date(),
      endDate: new Date(),
    });
  };

  const onOpenNdpsReport = () => {
    setReportAnchorEl(null);
    const quarters = getLastFourQuarters();
    setNdpsReportValues({
      visible: true,
      quarter: quarters[0]?.name ?? null,
    });
  };

  const onCloseNdpsReportModal = () => {
    setNdpsReportValues({ visible: false, quarter: null });
  };

  const onChangeNdpsReportModal = (name, value) => {
    const reqObj = { ...ndpsReportValues, [name]: value };
    if (name === "quarter") {
      reqObj.quarterErr = value ? "" : "This field is required";
    }
    setNdpsReportValues(reqObj);
  };

  const onDownloadNdpsReport = () => {
    const quarterErr = ndpsReportValues?.quarter
      ? ""
      : "This field is required";
    if (quarterErr) {
      return setNdpsReportValues({ ...ndpsReportValues, quarterErr });
    }
    const selectedQuarter = getLastFourQuarters().find(
      (q) => q?.name === ndpsReportValues?.quarter,
    );
    if (!selectedQuarter) return;
    const url = `${baseURL}/clinic/stock/export/ndps-fda-quarterly?clinicId=${clinicDet?.id}&startDate=${selectedQuarter?.startDate}&endDate=${selectedQuarter?.endDate}`;
    window.open(url, "_blank");
    onCloseNdpsReportModal();
  };

  const onCloseReportModal = () => {
    setReportModalValues({ visible: false });
  };

  const onChangeReportModal = (name, value) => {
    const reqObj = { ...reportModalValues, [name]: value };
    if (name === "year") {
      const monthOptions = getMonthOptions(value);
      if (!monthOptions.some((li) => li?.value === reqObj?.month)) {
        reqObj.month = monthOptions[monthOptions.length - 1]?.value ?? null;
      }
      reqObj.yearErr = value ? "" : "This field is required";
    }
    if (name === "month") {
      reqObj.monthErr = value ? "" : "This field is required";
    }
    if (name === "startDate") {
      reqObj.startDateErr = value ? "" : "This field is required";
    }
    if (name === "endDate") {
      reqObj.endDateErr = value ? "" : "This field is required";
    }
    setReportModalValues(reqObj);
  };

  const onDownloadPeriodReport = () => {
    if (isDateRangeReport(reportModalValues?.type)) {
      const startDateErr = reportModalValues?.startDate
        ? ""
        : "This field is required";
      const endDateErr = reportModalValues?.endDate
        ? ""
        : "This field is required";
      if (startDateErr || endDateErr) {
        return setReportModalValues({
          ...reportModalValues,
          startDateErr,
          endDateErr,
        });
      }
      const { startDate, endDate } = formatReportDateRange(
        reportModalValues?.startDate,
        reportModalValues?.endDate,
      );
      const endpoint =
        reportModalValues?.type === "accounts-receivables"
          ? "/payments/search/export-outstanding-excel"
          : "/clinic/payment/consolidated-financial-summary/export";
      const url = `${baseURL}${endpoint}?clinicId=${clinicDet?.id}&startDate=${startDate}&endDate=${endDate}`;
      window.open(url, "_blank");
      onCloseReportModal();
      return;
    }
    const yearErr = reportModalValues?.year ? "" : "This field is required";
    const monthErr = reportModalValues?.month ? "" : "This field is required";
    if (yearErr || monthErr) {
      return setReportModalValues({ ...reportModalValues, yearErr, monthErr });
    }
    const endpoint =
      reportModalValues?.type === "gst"
        ? "gst-report/invoices/export"
        : "gst-report/export";
    const url = `${baseURL}/clinic/payment/${endpoint}?clinicId=${clinicDet?.id}&year=${reportModalValues?.year}&month=${reportModalValues?.month}`;
    window.open(url, "_blank");
    onCloseReportModal();
  };

  const onCloseH1Mod = () => {
    setH1ReportModValues({ visible: false });
  };

  const onChange = (name, value) => {
    const reqObj = { ...h1ReportModValues, [name]: value };
    if (name === "stockName") {
      reqObj.stockNameErr = Array.isArray(value)
        ? value?.length > 0
          ? ""
          : "This field is required"
        : "This field is required";
    }
    setH1ReportModValues(reqObj);
  };

  const onGenerate = () => {
    if (
      h1ReportModValues?.stockName?.length === 0 ||
      !h1ReportModValues?.stockName
    ) {
      return setH1ReportModValues({
        ...h1ReportModValues,
        stockNameErr: "This field is required",
      });
    }
    onH1ApiCall(1);
    setH1ReportModValues({ ...h1ReportModValues, valueEntered: true });
  };

  const handleChangePage = (e, pge) => {
    onH1ApiCall(pge);
  };

  const getTableData = () => {
    return (h1Records?.data ?? [])?.map((li) => ({
      ...li,
      customerName: li?.userName,
      date:
        li?.createDate?.length > 0
          ? moment(li?.createDate).format("DD MMM YYYY")
          : "",
      invoiceNumber: li?.invoiceNo ?? "",
      tradeName: li?.stockTradeName ?? "",
      expirtDate:
        li?.expiryDate?.lenght > 0
          ? moment(li?.expiryDate).format("DD MMM YYYY")
          : "",
    }));
  };

  const getH1Stocks = () => {
    const filteredList = (stocks ?? [])?.filter(
      (stc) => (stc?.drugSchedule ?? "")?.toLowerCase() === "schedule h1",
    );
    const reqList = filteredList?.map((li) => {
      return {
        name: li?.tradeName ?? li?.productName ?? "",
        value: li?.stockId ?? null,
        stockId: li?.stockId ?? null,
        drugSchedule: li?.drugSchedule ?? "",
      };
    });
    return reqList;
  };

  const periodReportModal = () => (
    <CustomModal
      open={reportModalValues?.visible}
      onClose={onCloseReportModal}
      header={getReportModalHeader(reportModalValues?.type)}
      rightModal
      modalWidth={30}
    >
      <div className="ph20">
        {isDateRangeReport(reportModalValues?.type) ? (
          <div className="flex-row-between">
            <div className="w48Per">
              <div className="txt-semi-bold fs14 light-grey">
                Start Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                value={reportModalValues?.startDate}
                fullWidth
                mobileDate
                handleChange={(e) =>
                  onChangeReportModal("startDate", e?.target?.value)
                }
                error={!!reportModalValues?.startDateErr}
                helperText={reportModalValues?.startDateErr}
              />
            </div>
            <div className="w48Per">
              <div className="txt-semi-bold fs14 light-grey">
                End Date <span className="red-color">*</span>
              </div>
              <CustomTextField
                value={reportModalValues?.endDate}
                fullWidth
                mobileDate
                handleChange={(e) =>
                  onChangeReportModal("endDate", e?.target?.value)
                }
                error={!!reportModalValues?.endDateErr}
                helperText={reportModalValues?.endDateErr}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="txt-semi-bold fs14 light-grey">
              Year <span className="red-color">*</span>
            </div>
            <CustomSelect
              select
              list={getYearOptions()}
              value={reportModalValues?.year ?? ""}
              handleChange={(e) =>
                onChangeReportModal("year", e?.target?.value)
              }
              error={!!reportModalValues?.yearErr}
              helperText={reportModalValues?.yearErr}
            />
            <div className="txt-semi-bold fs14 light-grey mt10">
              Month <span className="red-color">*</span>
            </div>
            <CustomSelect
              select
              list={getMonthOptions(reportModalValues?.year)}
              value={reportModalValues?.month ?? ""}
              handleChange={(e) =>
                onChangeReportModal("month", e?.target?.value)
              }
              error={!!reportModalValues?.monthErr}
              helperText={reportModalValues?.monthErr}
            />
          </>
        )}
        <div className="flex1-end mt20">
          <div>
            <CustomButton
              text="Download"
              onClick={onDownloadPeriodReport}
              smallBtn
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );

  const ndpsReportModal = () => (
    <CustomModal
      open={ndpsReportValues?.visible}
      onClose={onCloseNdpsReportModal}
      header="NDPS Drug Report"
      rightModal
      modalWidth={30}
    >
      <div className="ph20">
        <div className="txt-semi-bold fs14 light-grey">
          Quarter <span className="red-color">*</span>
        </div>
        <CustomSelect
          select
          list={getLastFourQuarters().map((quarter) => ({
            name: quarter.name,
            value: quarter.name,
          }))}
          value={ndpsReportValues?.quarter ?? ""}
          handleChange={(e) =>
            onChangeNdpsReportModal("quarter", e?.target?.value)
          }
          error={!!ndpsReportValues?.quarterErr}
          helperText={ndpsReportValues?.quarterErr}
        />
        <div className="flex1-end mt20">
          <div>
            <CustomButton
              text="Download"
              onClick={onDownloadNdpsReport}
              smallBtn
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );

  const commonTopBar = () => {
    return (
      <TopBar>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <div
                className="ph10pv3"
                onClick={() => handleChangeTab("Dashboard")}
              >
                <div
                  className={`flex-center cursor ${
                    activeTab === "Dashboard"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Dashboard
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleChangeTab("Payments")}
              >
                <div
                  className={`flex-center cursor ${
                    activeTab === "Payments"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Payments
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleChangeTab("Returns")}
              >
                <div
                  className={`flex-center cursor ${
                    activeTab === "Returns"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Returns
                </div>
              </div>
              {activeTab === "PointOfSales" ? (
                <div
                  className="ph10pv3"
                  // onClick={() => handleChangeTab("PointOfSales")}
                >
                  <div
                    className={`flex-center cursor ${
                      activeTab === "PointOfSales"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Point of Sale
                  </div>
                </div>
              ) : null}
              <div
                className="ph10pv3"
                onClick={() => handleChangeTab("Reports")}
              >
                <div
                  className={`flex-center cursor ${
                    activeTab === "Reports"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Reports
                </div>
              </div>
              <div className="ph10pv3">
                <div
                  onMouseEnter={(e) => {
                    setMasterAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    activeTab === "Master"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Master <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={masterAnchorEl}
                  open={Boolean(masterAnchorEl)}
                  onClose={() => setMasterAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setMasterAnchorEl(null),
                  }}
                >
                  <MenuItem
                    onClick={() => handleChangeMaster("Payment Method")}
                  >
                    Payment Method
                  </MenuItem>
                  <MenuItem onClick={() => handleChangeMaster("Discount")}>
                    Discount
                  </MenuItem>
                </Menu>
              </div>
              <div className="ph10pv3">
                <div
                  onMouseEnter={(e) => {
                    setReportAnchorEl(e.currentTarget);
                  }}
                  className={`flex-center cursor ${
                    activeTab === "Download Reports"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Download Reports <ArrowDropDownIcon fontSize="small" />
                </div>
                <Menu
                  anchorEl={reportAnchorEl}
                  open={Boolean(reportAnchorEl)}
                  onClose={() => setReportAnchorEl(null)}
                  MenuListProps={{
                    onMouseLeave: () => setReportAnchorEl(null),
                  }}
                >
                  <MenuItem onClick={onOpenH1Report}>
                    Schedule H1 Report
                  </MenuItem>
                  <MenuItem onClick={() => onOpenPeriodReport("gst")}>
                    GST Report
                  </MenuItem>
                  <MenuItem onClick={() => onOpenPeriodReport("hsn")}>
                    HSN Summary
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      onOpenDateRangeReport("accounts-receivables")
                    }
                  >
                    Accounts Receivables Report
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      onOpenDateRangeReport("consolidated-financial-summary")
                    }
                  >
                    Consolidated Financial Summary
                  </MenuItem>
                  <MenuItem onClick={onOpenNdpsReport}>
                    NDPS Drug Report
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </Grid>
        </Grid>
      </TopBar>
    );
  };

  // If Reports is selected, render only the App component
  if (activeTab === "Reports") {
    return (
      <>
        {commonTopBar()}
        <div
          style={{
            maxHeight: "calc(100vh - 120px)",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "0 10px 0 10px",
          }}
        >
          <Main />
        </div>
        {periodReportModal()}
        {ndpsReportModal()}
      </>
    );
  }

  // For other tabs, render with VetAndUpcomingAppointments wrapper
  return (
    <>
      <VetAndUpcomingAppointments
        left={false}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        right={false}
        // right={activeTab === "PointOfSales"}
      >
        {commonTopBar()}
        <div
        // style={{
        //   maxHeight: "calc(100vh - 120px)",
        //   overflowY: "auto",
        //   overflowX: "hidden",
        //   padding: "0 10px 0 10px",
        // }}
        >
          {activeTab === "Payments" ? (
            <Payments
              posPayId={posPayId}
              setPosPayId={setPosPayId}
              paymentTableType={paymentTableType}
              setPaymentTableType={setPaymentTableType}
              setSelectedPaymentTab={setSelectedPaymentTab}
              selectedPaymentTab={selectedPaymentTab}
              setPaymentId={setPaymentId}
              setSelecetdPayment={setSelecetdPayment}
              setPosModVsble={setPosModVsble}
              setActiveTab={setActiveTab}
            />
          ) : null}
          {activeTab === "Returns" ? <Returns /> : null}
          {activeTab === "PointOfSales" ? (
            <PointOfSaleNew
              selectedPayment={selectedPayment}
              setSelecetdPayment={setSelecetdPayment}
              setActiveTab={setActiveTab}
            />
          ) : // <PointOfSales
          // selectedPayment={selectedPayment}
          // setSelecetdPayment={setSelecetdPayment}
          //   paymentId={paymentId}
          //   setPaymentId={setPaymentId}
          //   setActiveTab={setActiveTab}
          //   setPosPayId={setPosPayId}
          //   setPosModVsble={setPosModVsble}
          //   posModVsble={posModVsble}
          // />
          null}
          {activeTab === "Master" ? (
            <Box sx={{ padding: "20px" }}>
              {subTab === "Payment Method" ? <PaymentMethod /> : <Discount />}
            </Box>
          ) : null}
          {activeTab === "Dashboard" ? (
            <PaymentDashboard
              setActiveTab={setActiveTab}
              setPosModVsble={setPosModVsble}
              setSelecetdPayment={setSelecetdPayment}
              setPaymentId={setPaymentId}
              setPaymentTableType={setPaymentTableType}
              setSelectedPaymentTab={setSelectedPaymentTab}
            />
          ) : null}
        </div>
      </VetAndUpcomingAppointments>

      <CustomModal
        open={h1ReportModValues?.visible}
        onClose={onCloseH1Mod}
        header="Schedule H1 Report"
        modal={h1ReportModValues?.valueEntered}
        rightModal={!h1ReportModValues?.valueEntered}
        modalWidth={h1ReportModValues?.valueEntered ? 95 : 30}
      >
        <div className="scroll-90vh">
          {h1ReportModValues?.valueEntered ? (
            <div>
              <div className="flex1-end">
                <div className="mr20">
                  <CustomButton
                    text="⬇"
                    onClick={handleChangeReport}
                    smallBtn
                  />
                </div>
              </div>
              <CustomTable
                columns={tblHdrs}
                grey
                datas={getTableData()}
                page={page}
                rowsPerPage={itemSize}
                totalRecords={h1Records?.totalRecords}
                handleChangePage={handleChangePage}
              />
            </div>
          ) : (
            <div className="ph20">
              <div className="txt-semi-bold fs14 light-grey">
                Stock Name <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={getH1Stocks()}
                value={h1ReportModValues?.stockName ?? []}
                handleChange={(e) => {
                  onChange("stockName", e?.target?.value);
                }}
                multiSelectSearchCheck
                error={!!h1ReportModValues?.stockNameErr}
                helperText={h1ReportModValues?.stockNameErr}
              />
              <div className="flex-row-between mt10">
                <div className="w48Per">
                  <div className="txt-semi-bold fs14 light-grey">
                    Start Date
                  </div>
                  <CustomTextField
                    value={h1ReportModValues?.startDate}
                    fullWidth
                    mobileDate
                    handleChange={(e) =>
                      onChange("startDate", e?.target?.value)
                    }
                  />
                </div>
                <div className="w48Per">
                  <div className="txt-semi-bold fs14 light-grey">End Date</div>
                  <CustomTextField
                    value={h1ReportModValues?.endDate}
                    fullWidth
                    mobileDate
                    handleChange={(e) => onChange("endDate", e?.target?.value)}
                  />
                </div>
              </div>
              <div className="flex1-end mt20">
                <div>
                  <CustomButton text="Generate" onClick={onGenerate} smallBtn />
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomModal>

      {periodReportModal()}
      {ndpsReportModal()}

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure want to delete the payment?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDelMod} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDelete}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ClinicPayments;
